import { render, staticRenderFns } from "./APIDashboard.vue?vue&type=template&id=940f02bc&scoped=true&"
import script from "./APIDashboard.vue?vue&type=script&lang=ts&"
export * from "./APIDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./APIDashboard.vue?vue&type=style&index=0&id=940f02bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "940f02bc",
  null
  
)

export default component.exports